module.exports = __webpack_public_path__ + "img/screen.21e345fb.png";